import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import BackButton from "../../../../components/View/BackButton";
import { IconMailSearch } from "@tabler/icons-react";
import { verifyEmails } from "../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { useProfileStore } from "../../../../stores/UserStore";

const ListEmailVerify = ({ current, onFinish, closeMenu, hidden }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    verifyEmails({
      contact_list_id: current.id,
    })
      .then((res) => {
        notifications.show({
          message: lang.contact_lists.email_verifier.success,
          color: "tertiary.8",
        });
        close();
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  const handleClose = () => {
    close();
    closeMenu?.();
  };

  if (
    !(profile.permissions?.find((x) => x.name === "verifEmail")?.value === true)
  ) {
    return "";
  }

  return (
    <>
      <Button
        id="email-verifier-button"
        onClick={open}
        leftSection={<IconMailSearch size={18} />}
        color="primary"
        variant="subtle"
        justify="start"
        display={hidden ? "none" : "flex"}
      >
        {lang.contact_lists.email_verifier.label}
      </Button>

      {opened && (
        <Modal
          opened={opened}
          size={"md"}
          onClose={handleClose}
          title={
            <>
              {lang.contact_lists.email_verifier.dialog.title}{" "}
              <b>
                {current?.name} #{current.id}
              </b>
            </>
          }
        >
          <Stack component={"form"} onSubmit={handleSubmit} gap={"xs"}>
            <Text c={"dimmed"}>
              {lang.contact_lists.email_verifier.dialog.text}
            </Text>

            <Group justify="end" mt={"md"}>
              <BackButton onClick={handleClose} />

              <Button
                leftSection={<IconMailSearch size={18} />}
                loading={loading}
                color="primary"
                type="submit"
              >
                {lang.contact_lists.email_verifier.dialog.submit_button}
              </Button>
            </Group>
          </Stack>
        </Modal>
      )}
    </>
  );
};

export default ListEmailVerify;
